import { createStore, applyMiddleware, Store, StoreEnhancerStoreCreator } from 'redux';
import { IApplicationState } from './store/ApplicationState';
import { localReducers } from './store/reducers';
import { createLogger } from 'redux-logger';
import promiseMiddleware from 'redux-promise-middleware';
import { composeWithDevTools } from 'redux-devtools-extension';
import { routerMiddleware } from 'connected-react-router';

export default function configureStore(history: any, initialState?: IApplicationState) {
  // Build middleware. These are functions that can process the actions before they reach the store.
  // const windowIfDefined = typeof window === 'undefined' ? null : window as any;
  // If devTools is installed, connect to it

  const rMiddleware = routerMiddleware(history);

  const createStoreWithMiddleware = composeWithDevTools(
    applyMiddleware(
      createLogger({ diff: false }),
      promiseMiddleware,
      rMiddleware
    ),
    <S>(next: StoreEnhancerStoreCreator<S>) => next
  )(createStore);

  // Combine all reducers and instantiate the app-wide store instance
  const store = createStoreWithMiddleware(localReducers(history), initialState) as Store<IApplicationState>;

  return store;
}